module.exports = __webpack_public_path__ + "img/logo.b04b20c5.png";